exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3Y-6hfAVy2MF_hsuYhs0w6 i{position:absolute;top:10px;right:10px;font-size:24px;color:#f50;font-weight:700}._3Y-6hfAVy2MF_hsuYhs0w6{position:relative}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/molecules/InputIcon/style.css"],"names":[],"mappings":"AAAA,2BACI,kBAAmB,AACnB,SAAS,AACT,WAAW,AACX,eAAgB,AAChB,WAAsB,AACtB,eAAkB,CACrB,AACD,yBACI,iBAAmB,CACtB","file":"style.css","sourcesContent":[".icon i{\n    position: absolute;\n    top:10px;\n    right:10px;\n    font-size: 24px;\n    color:rgb(255, 85, 0);\n    font-weight: bold;\n}\n.icon{\n    position: relative;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "_3Y-6hfAVy2MF_hsuYhs0w6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/molecules/InputIcon/style.css
// module id = 826
// module chunks = 0 1 2 3 7 8